/**
 * @file api/tasks.js
 * @location src/integrations/supabase/api/tasks.js
 * @role 업무(tasks) 쓰기 RPC 래퍼. 각 함수는 매핑된 Task 반환 또는 throw.
 *
 * 권한·핸드셰이크 규칙은 서버 RPC(0002_rpc_tasks.sql)가 강제. 여기선 인자 전달만.
 */
import { rowToTask } from '../mappers.js';
import { callRpc, callRpcId } from './_call.js';

const callTask = (fn, args) => callRpc(fn, args, rowToTask);

/** 매니저 발신. id 는 호출 측에서 생성(낙관적 업데이트와 서버 row id 일치). */
export const assignTask = (t) => callTask('rpc_assign_task', {
  p_id: t.id, p_title: t.title, p_priority: t.priority ?? 'normal',
  p_aee: t.aee ?? null, p_due: t.due ?? null,
  p_date_kind: t.dateKind ?? null, p_note: t.note ?? null,
  p_refs: t.refs && t.refs.length ? t.refs : null,
});

export const editTask = (id, c) => callTask('rpc_edit_task', {
  p_id: id, p_title: c.title, p_priority: c.priority ?? null,
  p_aee: c.aee ?? null, p_due: c.due ?? null,
  p_date_kind: c.dateKind ?? null, p_note: c.note ?? null,
});

export const acknowledgeTask = (id) => callTask('rpc_acknowledge_task', { p_id: id });
export const toggleTask      = (id) => callTask('rpc_toggle_task', { p_id: id });
export const cancelTask      = (id, reason) => callTask('rpc_cancel_task', { p_id: id, p_reason: reason });
export const trashTask       = (id) => callTask('rpc_trash_task', { p_id: id });
export const restoreTask     = (id) => callTask('rpc_restore_task', { p_id: id });
export const purgeTask       = (id) => callRpcId('rpc_purge_task', { p_id: id }, id);
